export const SITE = {
  name: "Universal Engineers",
  short: "UE",
  founded: 1972,
  email: "universalengineers.ncg@gmail.com",
  phoneDisplay: "+91 9811107174",
  phoneHref: "tel:+919811107174",
  landlineDisplay: "011-45578788",
  landlineHref: "tel:+9145578788",
  whatsappNumber: "919811107174",
  whatsappText:
    "Hello Universal Engineers, I would like to enquire about 3M cable accessories.",
  addressLine1: "1503, Bhagirath Palace",
  addressLine2: "Delhi — 110006, India",
  address2Line1: "134, Patparganj Industrial Area",
  address2Line2: "Delhi — 110092, India",
  heroAddress: "1503, Electrical Market, Bhagirath Palace, Chandni Chowk, New Delhi 110006",
  hours: "Mon – Sat · 10:30 AM – 7:30 PM",
  domain: "https://universal-engineers.com",
  mapEmbed:
    "https://www.google.com/maps?q=1503,+Electrical+Market,+Bhagirath+Palace,+Chandni+Chowk,+New+Delhi+110006&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=1503,+Electrical+Market,+Bhagirath+Palace,+Chandni+Chowk,+New+Delhi+110006",
};

export const waLink = `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(
  SITE.whatsappText
)}`;

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMAGES = {
  heroGrid:
    "https://images.unsplash.com/photo-1543489816-c87b0f5f7dd4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  substation:
    "https://images.unsplash.com/photo-1767884161319-c00ae43bca39?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  switchgear:
    "https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  engineer:
    "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  warehouse: "/img/warehouse-3m.jpg",
};
